import React, { createContext, useContext, useRef, useState } from "react";
// import Confetti from 'https://cdn.skypack.dev/canvas-confetti';
import SuccessAud from '../assets/sounds/endorse-success.wav';

const CoinContext = createContext();
let successSound = new Audio(SuccessAud);

export const useCoinAnimation = () => useContext(CoinContext);

export function CoinAnimationProvider({ children }) {
  const [walletCoins, setCoins] = useState([]);
//   const [moneyCount, setMoneyCount] = useState(0);
  const [walletBounce, setBounce] = useState(false);
  const walletRef = useRef(null);
  const [floatingCredit, setFloatingCredit] = useState(null);

  const triggerCoinAnimation = (count = 5, data={}) => {
    if (!walletRef.current) return;
    const isShowConfetti = data.show_confetti||true;
    //Splash gif
    // if(isShowConfetti){
    //   Confetti({zIndex: 99999, origin: {y: 0.7}});
    // }
    const walletRect = walletRef.current.getBoundingClientRect();
    const newCoins = Array.from({ length: count }, (_, i) => {
      const offsetX = (Math.random() - 0.5) * 100;
      const offsetY = (Math.random() - 0.5) * 200;

      const startX = window.innerWidth / 2 + offsetX;
      const startY = window.innerHeight / 2 + offsetY;
      const endX = walletRect.left + walletRect.width / 2;
      const endY = walletRect.top + walletRect.height / 2-30;
      return {
        id: Date.now() + i,
        startX,
        startY,
        deltaX: endX - startX,
        deltaY: endY - startY,
        visible: false,
      };
    });

    setCoins(newCoins);

    setTimeout(() => {
      setCoins((prev) =>
        prev.map((coin) => ({ ...coin, visible: true }))
      );
    }, 10);

    setTimeout(() => {
        //Play Sound
        successSound.play();
        setFloatingCredit(`+${count}`);
      setCoins([]);
    //   setMoneyCount((prev) => prev + count);
      setBounce(true);
      setTimeout(() => setBounce(false), 400);
    }, 850);

    setTimeout(() => setFloatingCredit(null), 1200);
  };

  return (
    <CoinContext.Provider value={{ triggerCoinAnimation, walletRef, walletCoins, walletBounce, floatingCredit }}>{/* moneyCount */}
      {children}
    </CoinContext.Provider>
  );
}
